document.addEventListener('DOMContentLoaded', function() {

  /* ─── Mobile Nav Toggle ─── */
  const toggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.querySelector('.nav-list');
  
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true' ? false : true;
      this.setAttribute('aria-expanded', expanded);
      nav.classList.toggle('active');
    });
  }

  /* ─── Fade-in on Scroll ─── */
  const fadeElements = document.querySelectorAll('.section-header, .service-card, .testimonial-card, .stat-card, .client-item');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  fadeElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  /* ─── Smooth Scroll for Anchor Links ─── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* ─── Header scroll effect ─── */
  const header = document.querySelector('.site-header');
  let lastScroll = 0;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 200) {
      header.style.background = 'rgba(26, 42, 58, 0.98)';
    } else {
      header.style.background = 'rgba(26, 42, 58, 0.95)';
    }
    lastScroll = currentScroll;
  });

});
